<template>
    <div class="">
        <h1>Home</h1>
    </div>
</template>

<script>
export default {
    name: 'wellful-home',
    data() {
        return {
            activeItem: 0
        }
    },
    components: {}
}
</script>

<style scoped></style>
